import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { baseUrlApi } from "../../proxy";
import CAxios from "../utils/CAxios";

interface LoginPayload {
  login: string;
  password: string;
}

export const toLogin = createAsyncThunk(
  "login/toLogin",
  async (data: LoginPayload) => {
    try {
      const response = await axios.post(`${baseUrlApi}login`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);